import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Table, Text, ActionLink, Actions } from '@custom-components';
import LocaleLink from '../../../../components/LocaleLink';
import { OverflowContainer, PulseWrapper } from '../List.styles';
import { adminPropertyShape } from '../helperFunctions';
import { Secure } from '../../../../containers/admin/Secure/Secure';
import { permission } from '../../../../containers/admin/Secure/permission';

class AdminPropertyTable extends PureComponent {
  static propTypes = {
    data: PropTypes.arrayOf(adminPropertyShape).isRequired,
    messages: PropTypes.shape({}),
    openTaxes: PropTypes.func.isRequired,
    openEditor: PropTypes.func.isRequired
  };

  static defaultProps = {
    messages: {
      nameLabel: 'Property Name',
      locationLabel: 'Location',
      updatedLabel: 'Last Updated',
      statusLabel: 'Status',
      actionHeaderLabel: '',
      emailLabel: 'Contact Email'
    }
  };

  resolveMessages = () => {
    const { messages } = this.props;
    return { ...AdminPropertyTable.defaultProps.messages, ...messages };
  };

  renderRows = () => {
    const { data, openTaxes, openEditor } = this.props;

    if (!data) return null;

    return data.map((property) => {
      const { id, name, status, lastUpdated, city, region, emailAddress, taxFeeTemplate } = property;

      return {
        id,
        name: (
          <div>
            <Text.CopyBody tagName="span">{name}</Text.CopyBody>
            <br />
            <div style={{ marginLeft: '20px' }}>
              <Text.CopyParagraph tagName="span">
                {city}, {region}
              </Text.CopyParagraph>
            </div>
          </div>
        ),
        email: (
          <Text.CopyParagraph tagName="span">
            <span style={{ wordWrap: 'break-word' }}>{emailAddress || 'No email set'}</span>
          </Text.CopyParagraph>
        ),
        lastUpdated: (
          <Text.CopyParagraph tagName="span">
            <span style={{ whiteSpace: 'nowrap' }}>{lastUpdated}</span>
          </Text.CopyParagraph>
        ),
        status: <Text.CopyParagraph tagName="span">{status}</Text.CopyParagraph>,
        actions: (
          <Actions>
            <Secure reqPermission={permission.edit.rateCard}>
              <LocaleLink route="RateCardsSelected" params={{ propertyId: id.toString(), propertyName: name }}>
                <ActionLink>
                  <Text.HeadingSixth noMargins>Rate Card</Text.HeadingSixth>
                </ActionLink>
              </LocaleLink>
            </Secure>
            <Secure reqPermission={permission.edit.taxTemplate}>
              <ActionLink onClick={() => openTaxes(id, taxFeeTemplate)}>
                <Text.HeadingSixth noMargins>Tax Template</Text.HeadingSixth>
              </ActionLink>
            </Secure>
            <Secure reqPermission={permission.edit.supplierManagement}>
              <ActionLink onClick={() => openEditor(id, name)}>
                <Text.HeadingSixth noMargins>View/Edit Details</Text.HeadingSixth>
              </ActionLink>
            </Secure>
          </Actions>
        )
      };
    });
  };

  render() {
    const { nameLabel, updatedLabel, statusLabel, actionHeaderLabel, emailLabel } = this.resolveMessages();
    return (
      <OverflowContainer>
        <PulseWrapper>
          <Table
            minTableWidth="100%"
            contentCellsConfig={{ name: { style: { minWidth: '150px' } }, email: { style: { maxWidth: '200px' } } }}
            rows={[
              { id: 'name', label: nameLabel },
              { id: 'email', label: emailLabel },
              { id: 'lastUpdated', label: updatedLabel },
              { id: 'status', label: statusLabel },
              { id: 'actions', label: actionHeaderLabel }
            ]}
          >
            {this.renderRows()}
          </Table>
        </PulseWrapper>
      </OverflowContainer>
    );
  }
}

export default AdminPropertyTable;
